// src/views/grange.js
import React from "react";

const Grange = () => {
  return (
    <div className="page-hebergement">
      <h1>La Grange</h1>
      <p>Ici tu décris la grange, ses chambres, équipements, photos, etc.</p>
    </div>
  );
};

export default Grange;
